// ----------------------------------------------------------------------

const account = {
  displayName: 'User Name',
  email: 'test@admin.com',
  photoURL: '/static/mock-images/avatars/avatar_default.jpg'
};

export default account;
